module.exports = __webpack_public_path__ + "img/clip_image036.6503bb5d.png";